import { render } from "./BrandnewComp.vue?vue&type=template&id=eecf533e&scoped=true"
import script from "./BrandnewComp.vue?vue&type=script&lang=js"
export * from "./BrandnewComp.vue?vue&type=script&lang=js"

import "./BrandnewComp.vue?vue&type=style&index=0&id=eecf533e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eecf533e"]])

export default __exports__